import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import PreFooterCTA from "./PreFooterCTA";
import useScrollReveal from "@/hooks/useScrollReveal";
import { trackPageView } from "@/lib/tracking";

let lastTrackedPath = null;

export default function Layout() {
  const { pathname, hash, search } = useLocation();

  useEffect(() => {
    if (pathname === lastTrackedPath) return;
    lastTrackedPath = pathname;
    trackPageView(pathname, search);
    // `search` is read once per path change on purpose (UTM tags on the landing URL).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
      return undefined;
    }
    const id = decodeURIComponent(hash.slice(1));
    const align = (behavior) => document.getElementById(id)?.scrollIntoView({ behavior, block: "start" });
    // Re-align while late content (images, carousels) settles; stop if the user scrolls.
    const timers = [setTimeout(() => align("smooth"), 80), setTimeout(() => align("auto"), 800), setTimeout(() => align("auto"), 1600)];
    const cancel = () => timers.forEach(clearTimeout);
    window.addEventListener("wheel", cancel, { once: true, passive: true });
    window.addEventListener("touchstart", cancel, { once: true, passive: true });
    return () => {
      cancel();
      window.removeEventListener("wheel", cancel);
      window.removeEventListener("touchstart", cancel);
    };
  }, [pathname, hash]);

  // Wires a global IntersectionObserver to all `[data-reveal]` elements.
  useScrollReveal();

  return (
    <div className="min-h-screen bg-white text-slate-900 flex flex-col" data-testid="app-shell">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <PreFooterCTA />
      <Footer />
    </div>
  );
}
